import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

export default class extends PureComponent {
  static propTypes = {
    error: PropTypes.string,
  };


  constructor(props) {
    super(props);
    this.state = {
      error: props.error,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ error: nextProps.error });
  }

  render() {
    const { error } = this.state;
    if (!error) return null;
    return (
      <div className="alert alert-danger alert-error">
        <button
          className="close"
          data-dismiss="alert"
          onClick={() => {
                  this.setState({ error: undefined });
                }}
        >&times;
        </button>
        <FormattedMessage id={`error.${error}`} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorDisplay.js